import common from '../common'
const setWhiteColorModel = () => {
    // 安卓
    if( !common?.isAndroid_ios() ) {
        if( window?.androidNative?.setWhiteColorModel ) { 
            window.androidNative.setWhiteColorModel()
        }
    }else {
        if( window?.webkit?.messageHandlers?.setWhiteColorModel) {
            window?.webkit.messageHandlers.setWhiteColorModel.postMessage('')
        }
    }
}
export default setWhiteColorModel